// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth} from 'firebase/auth'
import 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB6iLteCc_oNuf5CV_DgG7HxCqKFH7fOhY",
  authDomain: "langfine-edead.firebaseapp.com",
  projectId: "langfine-edead",
  storageBucket: "langfine-edead.appspot.com",
  messagingSenderId: "92672127628",
  appId: "1:92672127628:web:cff386086330ac88c8c1a9"
};
const app = initializeApp(firebaseConfig);
export const auth =  getAuth(app);